<template>
  <div class="index-portale-mobile" :style="{ height: contenitoreHeight + 'px'}"  v-if="isToken">
    <header-app @menuMobile="menuMobile" @showMessages="changeShowMessages" 
    :contenitoreHeight="contenitoreHeight"></header-app>
    
    
    <nav-left v-if="showNavBar" :height="navBarHeight" :isMenuOpen="isMenuOpen" @menuMobile="menuMobile" class="menu"></nav-left>
    <div class="box-centrale-mobile no-padding">
      <!--<div class="row row-custom">
        <div class="titolo-app col-lg-24 no-padding">
          <span class="titolo-bold hidden-xs">HOME PAGE</span>
        </div>
      </div>-->
      <keep-alive >
        <router-view name="mobile" @closeMessages="closeMessages" class="contenuto col-xs-24 no-padding"
                    :showMessages="showMessages" :contenitoreHeight="contenitoreHeight - 70" :contentWidth="contentWidth"
                    v-show="!showModal"></router-view>
      </keep-alive>
      <div v-show="showModal" class="mobile_customize" :style="{ minHeight: (contenitoreHeight - 70) + 'px'}">
        <div class="elenco-messaggi" :style="{ minHeight: (contenitoreHeight - 70) + 'px'}">
          <el-card class="col-24" v-for="(item, index) in messaggiBlock"
                    :key="item.id" shadow="never"
                    :class="{ selected: (messaggio.id === item.id), important: isImportant(item) }" @click.native="selectMessage(item, index)">
            <div class="testata col-24">
              <div class="titolo">
                {{ item.titolo.toUpperCase() }}
              </div>
              <div class="priorita" v-if="(item.priorita === '1')">
                <icon name="riv-preferitiFull" scale="0.8"></icon>
              </div>
              <div class="allegati" v-if="(item.allegati.length > 0)">
                <icon name="riv-attach" scale="1"></icon>
              </div>
              <div class="presa-vis" v-if="(item.sePresaVis === 'Y' && item.presaVis === 'N')">
                <icon name="riv-acceptView" scale="1"></icon>
              </div>
                <div class="presa-vis-yes" v-if="(item.sePresaVis === 'Y' && item.presaVis === 'Y')">
                <icon name="riv-read" scale="1"></icon>
              </div>
            </div>
            <div class="col-24 testo" v-html="truncateCardModal(item.testo)"></div>
            <div class="footer col-24 no-padding">
              <div class="data">
                {{ $t('indexPortale')[new Date(item.dataPub.substr(0, 4), parseInt(item.dataPub.substr(5, 2)) - 1, item.dataPub.substr(8, 2)).getDay()] + ', ' + moment(item.dataPub, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
              </div>
              <div class="skip" v-if="(item.seSkip === 'Y')">
                <el-badge :value="'(' + item.numSkip + ')'" class="item" :hidden="(item.numSkip === '' || item.numSkip <= 0 )">
                  <icon name="riv-skip" scale="1"></icon>
                </el-badge>
              </div>
            </div>
          </el-card>
          <div class="action" v-if="enableEndBtn">
            <el-button class="mobile-el-button" :class="enableEndBtn ? 'primary' : 'secondary'" :disabled="!enableEndBtn" 
            @click.native="closeDialog()"> {{ $t('indexPortale.end').toUpperCase() }}</el-button>
          </div>
        </div>
        <el-dialog class="modal-message-mobile mobile_customize" :visible.sync="showMessaggio" @close="closeMessages"
                :append-to-body="true" 
                :title="messaggio.titolo.toUpperCase()" custom-class="custom-dialog"
                :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">

          <div class="col-24 no-padding data">
            {{ $t('messages')[new Date(messaggio.dataPub.substr(0, 4), parseInt(messaggio.dataPub.substr(5, 2)) - 1, messaggio.dataPub.substr(8, 2)).getDay()] + ', ' + moment(messaggio.dataPub, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
          </div>
          <div class="col-24 no-padding data" v-if="(messaggio.hasOwnProperty('dataExp'))">
            {{ $t('messages.scade') + ' ' + moment(messaggio.dataExp, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
          </div>
          <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
          <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
            <div v-for="mess in messaggio.allegati" :key="mess.keyDoc">
              <div class="col-24 no-padding allegato" @click="getAllegato(mess)">
                <icon class="icona" name="riv-attach" scale="1"></icon>
                <div class="titolo-allegato">
                  {{ mess.titolo }}
                </div>
              </div>
            </div>
          </div>
          <div slot="footer" class="footer">
            <div class="col-24 no-padding">
              <el-button class="mobile-el-button secondary" v-if="(messaggio.seSkip === 'Y' && messaggio.action !== 'Y')"  
                @click.native="setMessaggioService(messaggio, 'S', true)"> {{ $t('indexPortale.skip', {nskip: messaggio.numSkip}).toUpperCase() }}</el-button>
              <div v-else class="no-button" style="height:80px"></div>
              <el-button class="mobile-el-button primary" v-if="(messaggio.sePresaVis === 'Y' && messaggio.action !== 'Y')"  
                @click.native="setMessaggioService(messaggio, 'P', true)">{{ $t('indexPortale.presaVisione')}}</el-button>
              
              <el-button class="mobile-el-button secondary" v-if="(messaggio.action === 'Y')" 
              @click="closeMessageBlock()">{{ $t('indexPortale.close') }}</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
    
  </div>
</template>

<script>
  import HeaderApp from '@/components/HeaderAppMobile'
  import NavLeft from '@/components/NavLeftMobile'
  import moment from 'moment'
  import { bus } from './Bus'
  import mixinDownload from "../assets/mixins/downloadDoc.js";

  export default {
    name: 'IndexPortale',
    components: {HeaderApp, NavLeft},
    mixins: [mixinDownload],
    watch: {
      '$mq.resize': 'setSizes',
      'showMessages.val': function (newVal, oldVal) {
        this.setSizes()
      }
    },
    created: function () {
      if (this.$store.state.manutenzioneFunctionID){
        clearInterval(this.$store.state.manutenzioneFunctionID)
        this.$store.commit('set', { key: 'manutenzioneFunctionID', value: null })
      }
      if (this.$store.state.prossimaManutenzione && this.$store.state.prossimaManutenzione === 'Y') {
        let _this = this
        let valFunction = setInterval(function(){
          _this.$http.get('portale/' + _this.$store.state.country + '/manutenzione', {
            params: {}
          })
            .then(response => {
              if (response.body.rc === 1 && response.body.msg[0].msgId === '1286') {
                sessionStorage.setItem('token', '')
                sessionStorage.removeItem('token')
                sessionStorage.clear()
                clearInterval(_this.$store.state.manutenzioneFunctionID)
                _this.$store.commit('set', { key: 'manutenzioneFunctionID', value: null })
                _this.$router.push({ name: 'Login' })
              }
            })
        }, 600000);
        console.log('valFunction: ' + valFunction)
        _this.$store.commit('set', { key: 'manutenzioneFunctionID', value: valFunction })
      }
    },
    mounted: function () {
      /*// this.$router.push({name: 'HomePage'})
      if (sessionStorage.hasOwnProperty('codLang')) {
        this.$root.$i18n.locale = sessionStorage.getItem('codLang')
        //this.codLang = sessionStorage.getItem('codLang')
      } else {
        sessionStorage.setItem('codLang', process.env.codLang)
        this.$root.$i18n.locale = process.env.codLang
        //this.codLang = 'fr_FR'
      }*/
      window.addEventListener(
        "orientationchange",
        this.setSizes()
      )
      if (sessionStorage.getItem('token')) {
        this.getMessaggiBlock()
        this.getMessaggiCount()
      }
    },
    i18n: {
      messages: {
        it_IT: {
          indexPortale: {
            nuovi: 'Nuovi',
            letti: 'Letti',
            bacheca: 'Bacheca',
            messaggi: 'Messaggi',
            noMsg: 'Nessun messaggio',
            1: 'Lunedì',
            2: 'Martedì',
            3: 'Mercoledì',
            4: 'Giovedì',
            5: 'Venerdì',
            6: 'Sabato',
            0: 'Domenica',
            leggi: 'Leggi',
            priorita: {
              label: 'Priorità',
              1: 'Alta'
            },
            elimina: 'Elimina',
            scade: 'Scade il',
            ricevuto: 'Ricevuto il',
            presaVisione: 'Presa Visione',
            skip: 'Skip ({nskip})',
            end: 'fine',
            annulla: 'Annulla',
            close: 'Chiudi'
          }
        },
        fr_FR: {
          indexPortale: {
            nuovi: 'Nouveau',
            letti: 'Lu',
            bacheca: 'Petites Ann.',
            messaggi: 'Messages',
            noMsg: 'Pas de message',
            1: 'Lundi',
            2: 'Mardi',
            3: 'Mercredi',
            4: 'Jeudi',
            5: 'Vendredi',
            6: 'Sabbat',
            0: 'Dimanche',
            leggi: 'Lire',
            priorita: {
              label: 'Priorité',
              1: 'Haute'
            },
            elimina: 'Éliminer',
            scade: 'Expire le',
            ricevuto: 'Reçu le',
            presaVisione: 'Presa Visione',
            skip: 'Skip ({nskip})',
            end: 'fine',
            annulla: 'Annule',
            close: 'Fermer'
          }
        },
        es_ES: {
          indexPortale: {
            nuovi: 'Nuevos',
            letti: 'Leidos',
            bacheca: 'Prioritari',
            messaggi: 'Mensajes',
            noMsg: 'Sin mensaje',
            1: 'Lunes',
            2: 'Martes',
            3: 'Miércoles',
            4: 'Jueves',
            5: 'Viernes',
            6: 'Sábado',
            0: 'Domingo',
            leggi: 'Leer',
            priorita: {
              label: 'Prioridad',
              1: 'Alto'
            },
            elimina: 'Eliminar',
            scade: 'Vence el',
            ricevuto: 'Recibido el',
            presaVisione: 'Presa Visione',
            skip: 'Skip ({nskip})',
            end: 'fine',
            annulla: 'Annule',
            close: 'Cierra'
          }
        },
        de_DE: {
          indexPortale: {
            nuovi: 'Neu',
            letti: 'Gelesen',
            bacheca: 'Schwarzes Brett',
            messaggi: 'Beiträge',
            noMsg: 'Keine nachricht',
            1: 'Montag',
            2: 'Dienstag',
            3: 'Mittwoch',
            4: 'Donnerstag',
            5: 'Freitag',
            6: 'Sabbat',
            0: 'Sonntag',
            leggi: 'Lesen',
            priorita: {
              label: 'Priorität',
              1: 'Hoch'
            },
            elimina: 'Beseitigen',
            scade: 'Läuft am ab',
            ricevuto: 'Eingegangen am',
            presaVisione: 'Presa Visione',
            skip: 'Skip ({nskip})',
            end: 'fine',
            annulla: 'Annule',
            close: 'Schließen'
          }
        },
        en_GB: {
          indexPortale: {
            nuovi: 'New',
            letti: 'Read',
            bacheca: 'Notice Board',
            messaggi: 'Messages',
            noMsg: 'No messages',
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday',
            0: 'Sunday',
            leggi: 'Read',
            priorita: {
              label: 'Priority',
              1: 'High'
            },
            elimina: 'Remove',
            scade: 'Expires',
            ricevuto: 'Received on',
            presaVisione: 'Presa Visione',
            skip: 'Skip ({nskip})',
            end: 'fine',
            annulla: 'Annule',
            close: 'Chiudi'
          }
        }
      }
    },
    data () {
      return {
        moment: moment,
        showMessages: {
          val: false,
          type: 1
        },
        navBarHeight: 0,
        messagesHeight: 0,
        contenitoreHeight: 0,
        contentWidth: 0,
        counterNuovi: 0,
        isMenuOpen: false,
        // Gestione Messaggi Bloccanti
        messaggio: {
          titolo: '',
          dataPub: '',
          dataExp: '',
          testo: '',
          allegati: []
        },
        showModal: false,
        showMessaggio: false,
        messaggiBlock: [],
        messaggiCount: {},
        counterPresaVis: 0,
        messaggiAction: [],
        reloadMessaggi: false
      }
    },
    computed: {
     isToken: function () {
        if (sessionStorage.getItem('token')) {
          return true
        } else {
          this.$router.push({name: 'Login'})
          return false
        }
      },
      showNavBar: function () {
        let EXCLUDED_PATH = ['presenze']
        return this.$route.path.indexOf('/app/presenze') < 0
      },
      enableEndBtn: function () {
        let result = true
        this.messaggiBlock.forEach((item) => {
          //if ((!item.action || item.action !== 'Y')) || (item.presaVis === 'N' && item.seLetto === 'Y')) {
          //if (item.action !== 'Y' && !(item.presaVis === 'N' && item.seLetto === 'Y')) {
          if (item.action !== 'Y') {
           result = false
          }
        })
        return result
      }
    },
    methods: {
      /*changeCounterNuovi: function (counterNuovi) {
        this.counterNuovi = counterNuovi
      },*/
      formatDate: function (date) {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      },
      setSizes: function () {
        if (document.documentElement.clientWidth <= 1540 && this.showMessages.type === 0) {
          this.showMessages.val = false
        }
        this.setNavBarHeight()
        this.setMessagesHeight()
        this.setContenitoreHeight()
        this.setContentWidth()
      },
      setNavBarHeight: function () {
        let height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        this.navBarHeight = height - 56
      },
      setMessagesHeight: function () {
        let height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        this.messagesHeight = height - 164
      },
      setContenitoreHeight: function () {
        this.contenitoreHeight = window.innerHeight
      },
      setContentWidth: function () {
        let width = document.documentElement.clientWidth || document.body.clientWidth
        this.contentWidth = width
        /* if (this.showMessages.val && this.showMessages.type === 0) {
          this.contentWidth = width - 565
        } else {
          this.contentWidth = width - 165
        } */
      },
      changeShowMessages: function () {
        this.$set(this.showMessages, 'val', !this.showMessages.val)
        /*if (document.documentElement.clientWidth > 1540) {
         this.showMessages.type = 0
         } else {
         this.showMessages.type = 1
         }*/
        this.showMessages.type = 1
      },
      closeMessages: function () {
        this.showMessages.val = false
      },
      menuMobile: function () {
        this.isMenuOpen = !this.isMenuOpen
      },
      getMessaggiBlock: function () {
        setTimeout(() => {
          let msg = {
            titolo: '',
            dataPub: '',
            dataExp: '',
            testo: '',
            allegati: []
          }
          // this.$set(this, 'disabledEndBtn', true)
          this.$set(this, 'showModal', false)
          this.$set(this, 'messaggio', msg)
          // this.$set(this, 'msg', msg)
          this.$set(this, 'showMessaggio', false)
          this.$http.get('communication/' + this.$store.state.country + '/messaggi', {
            params: {
              seBlock: 'Y',
              tipo: '',
              order: ''
            }
          })
            .then(response => {
              if (response.body.rc === 0) {
                if (response.body.data.length > 0) {

                  this.messaggiBlock = response.body.data.map(function(obj) {
                    if (obj.sePresaVis === 'Y' && obj.presaVis === 'Y') {
                      obj.action = 'Y'
                    } else if (obj.sePresaVis === 'N' && obj.seLetto === 'Y') {
                      obj.action = 'Y'
                    } else {
                      obj.action = 'N'
                    }
                    return obj
                  })
                  // this.$set(this, 'messaggiBlock', response.body.data)
                  this.$set(this, 'counterPresaVis', parseInt(response.body.attrib.presaVis))
                  this.$set(this, 'showModal', true)
                  this.$set(this, 'reloadMessaggi', false)
                }
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            })
        }, 200)
      },
      getMessaggiCount: function () {
        this.$set(this, 'messaggiCount', {})
        this.$http.get('communication/' + this.$store.state.country + '/messaggicount', {})
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'messaggiCount', response.body.data)
              this.$store.commit('set', { key: 'messaggiCount', value: response.body.data })
              bus.$emit('changeMessaggiCount')
            }
          })
      },
      selectMessage: function (item, index) {
        item.index = index
        this.$set(this, 'showMessaggio', true)
        this.$set(this, 'messaggio', item)
        if (item.seLetto === 'N') {
          // Richiamo il servizio di Lettura del documento solo l aprima volta
          this.setMessaggioService(item, 'L')
        }
      },
      setMessaggioService: function (messaggio, operazione) {
        let data = new FormData()
        data.append('id', messaggio.id)
        data.append('op', operazione)
        this.$http.post('communication/' + this.$store.state.country + '/messaggio', data)
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'reloadMessaggi', true)
              // Messaggio di tipo Presa Visione e Operazione 'P'
              if (messaggio.sePresaVis === 'Y' && operazione === 'P') {
                this.$set(this.messaggiBlock[messaggio.index], 'action', 'Y')
                this.$set(this.messaggiBlock[messaggio.index], 'presaVis', 'Y')
                this.closeMessageBlock()
              // Messaggio di tipo In Evidenza e Operazione 'L'
              } else if (messaggio.sePresaVis === 'N' && operazione === 'L') {
                this.$set(this.messaggiBlock[messaggio.index], 'action', 'Y')
                this.$set(this.messaggiBlock[messaggio.index], 'seLetto', 'Y')

                // Aggiorno il contatore messaggi salvato in Vuex
                let messaggiCount = this.$store.state.messaggiCount
                if (messaggiCount[messaggio.tipo] !== undefined && messaggiCount[messaggio.tipo] > 0) {
                  messaggiCount[messaggio.tipo] = messaggiCount[messaggio.tipo] - 1
                }
                if (messaggiCount.totale !== undefined && messaggiCount.totale > 0) {
                  messaggiCount.totale = messaggiCount.totale - 1
                }
                this.$store.commit('set', { key: 'messaggiCount', value: messaggiCount })
                bus.$emit('changeMessaggiCount')

              } else if (messaggio.sePresaVis === 'Y' && operazione === 'S') {
                this.$set(this.messaggiBlock[messaggio.index], 'action', 'Y')
                this.$set(this.messaggiBlock[messaggio.index], 'numSkip', parseInt(this.messaggiBlock[messaggio.index].numSkip) - 1)
                this.closeMessageBlock()
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      closeDialog: function () {
        let msg = {
          titolo: '',
          dataPub: '',
          dataExp: '',
          testo: '',
          allegati: []
        }
        this.$set(this, 'showModal', false)
        this.$set(this, 'messaggio', msg)
        // this.$set(this, 'msg', msg)
        this.$set(this, 'showMessaggio', false)
        this.$set(this, 'messaggiBlock', [])
        this.$set(this, 'counterPresaVis', 0)
        if (this.reloadMessaggi) {
          // Controllo se ho eseguito un operazione sui messaggi bloccanti e ricalcolo l'elenco dei messaggi Dashboard
          // bus.$emit('reloadMessaggi')
        }
      },
       closeMessageBlock: function () {
        this.$set(this, 'showMessaggio', false)
        let obj = {
          titolo: '',
          dataPub: '',
          dataExp: '',
          testo: '',
          allegati: []
        }
        this.$set(this, 'messaggio', obj)
      },
      truncateCard: function (text) {
        if (text != undefined && text.length > 100) {
          return text.substr(0, 100) + '...'
        } else {
          return text
        }
      },
      truncateCardModal: function (text) {
        if (text != undefined && text.length > 50) {
          return text.substr(0, 50) + '...'
        } else {
          return text
        }
      },
      isImportant: function (messaggio) {
        if (messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'Y') {
          // Documenti a cui è stata fatta la Presa Visione
          return false
        } else if (messaggio.action === 'Y') {
          // Documenti a cui è stata fatta un operazione
          return false
        } else if (messaggio.sePresaVis === 'N' && messaggio.seLetto === 'Y') {
          // Documenti senza Presa Visione che è già stato letto
          return false
        } else {
          return true
        }
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/general.less";
  @import "../assets/less/mobile_customize.less";

  body {
    overscroll-behavior: contain;
  } 
  .index-portale-mobile {
    .box-centrale-mobile {
      background-color: #fff;
      padding-top: 10px;
      overflow: auto;
      // margin-left: 5px;
      // margin-right: 5px;
    }
    .set-font();
    height: 100%;
    .menu {
     // padding-top: 15px;
      float: left;
    }
    .language-modal {
      .elemento {
        font-size: 14px;
        margin-top: 5px;
        margin-bottom: 20px;
        .label {
          color: @greenRiva;
        }
        .radio {
          margin-top: 5px;
          color: @greenRiva;
        }
        .value {
          color: #bbbbbb;
        }
        .textarea:focus {
          border: 1px solid @greenRiva;
        }
      }
    }
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px; @color: @greenRiva);
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 50px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .contenitore {
      //padding: 10px 0 10px 0;
      /*-webkit-box-shadow: 0 0 10px 2px #cecece;
      -moz-box-shadow: 0 0 10px 2px #cecece;
      box-shadow: 0 0 10px 2px #cecece;*/
      // background-color: #f5f3f3;
      margin: auto;
      overflow-x: hidden;
      text-align: center;
      //border-radius:5px;
    }
    .elenco-messaggi {
      height: 490px;
      overflow: auto;
      padding: 5px !important;
      .el-card {
        height: 115px;
        float: left;
        margin-bottom: 10px;
        border-radius: 0px;
        padding: 5px 10px !important;
        cursor: pointer;
        .el-card__body {
          padding: 0;
          height: 100%;
          .testata {
            width: 100%;
            height: 30px;
            padding: 0 !important;
            display: flex;
            justify-content: space-between;
            .titolo {
              width: 80%;
              .set-font(@family: 'os-semibold', @color: @greenRiva, @size: 14px);
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .priorita {
              margin-left: 10px;
              .fa-icon {
                color: red;
              }
            }
            .allegati {
              .fa-icon {
                color: @greenRiva;
              }
            }
            .presa-vis {
              .fa-icon {
                color: @rossoRiva;
              }
            }
            .presa-vis-yes {
                .fa-icon {
                color: @greenTick;
              }
            }
            .ricevuto {
              .set-font(@color: @greenRiva, @size: 10px);
              font-style: italic;
              margin-top: 3px;
            }
          }
          .testo {
            padding: 0 5px !important;
            .set-font(@size: 12px; @color: @textTable);
            text-align: left;
          }
          .footer {
            display: inline-block;
            position: absolute;
            bottom: 6px;
            left: 0;
            padding: 0 10px !important;
            .data {
              .set-font(@size: 10px);
              float: left;
              line-height: 20px;
              font-style: italic;
              padding-top: 2px;
            }
            .skip {
              float: right;
              margin-right: 2px;
              text-align: right;
              .el-badge {
                .fa-icon {
                  color: @oroRiva;
                }
                .el-badge__content {
                  border: none;
                  background-color: transparent;
                  color: #CBB385;
                  right: 10px;
                }
              }
            }
            .el-button {
              float: right;
              height: 23px;
              line-height: 20px;
              padding: 0 6px;
              border-color: @oroRiva !important;
              background-color: @oroRiva !important;
            }
          }
        }
      }
      & .selected {
        background-color: @hoverTbl;
      }
      & .important {
        border-left: 3px solid @greenRiva;
        .testo {
          .set-font(@color: @textTable, @size: 12px, @family: 'os-bold') !important;
        }
        .footer {
          .data {
            .set-font(@color: @greenRiva, @size: 10px, @family: 'os-bold') !important;
            font-style: normal;
          }
        }
      }
    }
  }

  .modal-message-mobile {
      .custom-dialog {
        height: 80% !important;
        width: 98% !important;
        margin-top: 20% !important;
      }
      .el-dialog {
        .el-dialog__body {
          height: -moz-calc(100% - 200px);
          height: -webkit-calc(100% - 200px);
          height: calc(100% - 200px);
          overflow: auto;
          padding-left: 0px;
          padding-right: 0px;
          .data {
            width: 100%;
            text-align: right;
            margin-top: 10px;
            .set-font(@size: 12px, @color: @textTable);
            font-style: italic;
            padding: 0 4px !important;
          }
          .priorita {
            margin-top: 15px;
            text-align: left;
            .prior-label {
              .set-font(@color: @textTable, @size: 14px, @family: 'os-semibold');
            }
            .prior-value {
              margin-left: 2px;
              .set-font(@color: red, @size: 14px, @family: 'os-semibold');
            }
            .prior-icon {
              .fa-icon {
                color: red;
                margin-top: -4px;
                margin-left: 2px;
              }
            }
          }
          .testo {
            margin-top: 20px;
            .set-font(@color: @textTable, @size: 13px);
            text-align: justify;
            height: auto;
            overflow: auto;
            padding-right: 5px !important;
          }
          .allegati {
            min-height: 30px;
            max-height: 120px;
            overflow: auto;
            margin-top: 30px;
            margin-bottom: 20px;
            .allegato {
              display: inline-block;
              .icona {
                width: 10%;
                float: left;
                padding-top: 2px;
              }
              .titolo-allegato {
                width: 85%;
                float: left;
                .set-font(@color: @greenRiva, @size: 13px);
                text-align: left;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            .allegato:hover {
              cursor: pointer;
            }
          }
        }
        .el-dialog__footer {
          padding: 10px 0 0;
          height: 160px;
          .footer {
            height: 45px;
            width: 100%;
            padding: 0 !important;
            .scade {
              padding: 10px 0 0 15px;
              .set-font(@color: @textTable, @size: 12px);
              font-style: italic;
            }
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/IndexPortaleMobile.vue